import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';

import Stack from '~/common/components/Stacks/Stack';

import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';
import DeleteIconButton from './buttons/DeleteIconButton';

export default function FieldArrayDeleteButton({
  component,
  handleClick: handleClickProp,
}: any) {
  const { setValue, getValues } = useFormContext();
  const { isVisible } = useConditionsEvaluator(component.conditions || {});

  const handleClick =
    handleClickProp ??
    (() => {
      const currentValues = getValues();
      const newArray = get<unknown[]>(
        currentValues as any,
        component.fieldArrayName,
        [],
      ).filter((_, index) => index !== component.metadata.index);
      setValue(component.fieldArrayName, newArray);
    });
  if (!isVisible) {
    return null;
  }
  return (
    <Stack
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100%',
        padding: component?.padding ?? '2rem 0rem',
      }}
    >
      <DeleteIconButton onClick={handleClick} />
    </Stack>
  );
}
